import React from 'react'

function navbar() {
  return (
    <div>
       <header className="bg-light p-3 shadow-sm w-full">
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center gap-2">
              {/* <img src="/api/placeholder/40/40" alt="Logo" className="h-10" /> */}
              <h1 className="fs-4 fw-bold text-warning">BuyByeQ Retail POS</h1>
            </div>
          </div>
        </header>
    </div>
  )
}

export default navbar
